<template>
  <el-dialog
    v-model="formVisible"
    :title="tableData.length > 1 ? '批量处理告警' : '告警处理'"
    @close="close"
    width="40%"
  >
    <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="120px"
      class="userForm"
    >
      <el-form-item label="处理结果" prop="">
        <el-radio-group v-model="ruleForm.alarmStatus">
          <el-radio :label="'1'">确认</el-radio>
          <el-radio :label="'2'">误报</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="处理意见" prop="">
        <el-input
          type="textarea"
          v-model="ruleForm.handleMessage"
          placeholder="处理意见"
        ></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <template v-if="!isDisabled">
        <h-button type="primary" @click="submitForm(ruleFormRef)"
          >确定</h-button
        >
        <h-button @click="close">取消</h-button>
      </template>
    </template>
  </el-dialog>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  computed,
  ref,
} from "vue";
import { eventassign } from "@/api/eventManagement/eventManagementApi.js";
import { getInfoHandle } from "@/api/alarmCenter/alarmCenter.js";
import { ElMessage } from "element-plus";
import _ from "lodash";
export default defineComponent({
  name: "",
  props: {
    tableSelection: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const ruleFormRef = ref();
    // const validate = new Validate(ruleFormRef.value);
    const state = reactive({
      formVisible: false,
      userFormData: {},
      ruleForm: {
        alarmStatus: "1",
        handleMessage: "",
        idList: [],
      },
      optionsJsList: [],
      optionsYhList: [],
      ruleFormBack: {},
      rules: {},
      options: [],
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    // state.ruleForm
    const refData = toRefs(state);
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
      state.userFormData = props.form;
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    // 禁用
    const isDisabled = computed(() => {
      return props.status === 3;
    });

    // 保存表单数据
    const submitForm = async () => {
      props.tableData.forEach((item) => {
        state.ruleForm.idList.push(item.id);
      });
      // console.log(state.ruleForm);
      // return;
      const res = await getInfoHandle(state.ruleForm);
      if (res.code === 0) {
        ElMessage.success("处理成功");
        context.emit("refresh");
        state.formVisible = false;
      } else {
        ElMessage.error("处理失败");
      }
    };
    const close = () => {
      context.emit("clearSelect");
      state.formVisible = false;
      state.ruleForm = _.cloneDeep(state.ruleFormBack);
    };

    return {
      ...refData,
      submitForm,
      close,
      ruleFormRef,
      isDisabled,
    };
  },
});
</script>
<style  lang='scss' scoped >
.userForm {
  width: 100%;
  // max-height: 300px;
  height: 200px;
  overflow: auto;
}
.formTitle {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  span {
    width: 3.5px;
    height: 16px;
    background-color: #5584ff;
    margin-right: 10px;
  }
}
.margLeftLabel {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>